var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88623 28.5623C3.88623 14.7092 15.1164 3.479 28.9696 3.479C42.8227 3.479 54.0529 14.7092 54.0529 28.5623C54.0529 42.4155 42.8227 53.6457 28.9696 53.6457C15.1164 53.6457 3.88623 42.4155 3.88623 28.5623ZM28.9696 6.979C17.0494 6.979 7.38623 16.6422 7.38623 28.5623C7.38623 40.4825 17.0494 50.1457 28.9696 50.1457C40.8897 50.1457 50.5529 40.4825 50.5529 28.5623C50.5529 16.6422 40.8897 6.979 28.9696 6.979Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3029 32.0623C19.2359 32.0623 20.8029 30.4953 20.8029 28.5623C20.8029 26.6293 19.2359 25.0623 17.3029 25.0623C15.3699 25.0623 13.8029 26.6293 13.8029 28.5623C13.8029 30.4953 15.3699 32.0623 17.3029 32.0623Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9696 32.0623C30.9026 32.0623 32.4696 30.4953 32.4696 28.5623C32.4696 26.6293 30.9026 25.0623 28.9696 25.0623C27.0366 25.0623 25.4696 26.6293 25.4696 28.5623C25.4696 30.4953 27.0366 32.0623 28.9696 32.0623Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6362 32.0623C42.5692 32.0623 44.1362 30.4953 44.1362 28.5623C44.1362 26.6293 42.5692 25.0623 40.6362 25.0623C38.7032 25.0623 37.1362 26.6293 37.1362 28.5623C37.1362 30.4953 38.7032 32.0623 40.6362 32.0623Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreTwo);
export default __webpack_public_path__ + "static/media/more-two.fafcbb00.svg";
export { ForwardRef as ReactComponent };